import ExpandImage from "@/icons/components/ExpandImage";
import Image from "@/shared/components/Image/new";
import { getImageFromClippingList } from "@/shared/functions/getImagesFunctions";
import styles from "./styles.module.css";

const CROPS = {
  desktop: "3_2_870x580",
  tablet: "3_2_630x420",
  mobile: "3_2_300x200",
};

const Img = ({ image, paragraph }) => {
  const { dimensions } = image;
  const { value, epigraphe, selectedClipping } = paragraph;

  const hasSelectedClipping =
    selectedClipping?.url && selectedClipping?._id;

  const mainImageObject = hasSelectedClipping
    ? null
    : getImageFromClippingList(value.clippings, CROPS.desktop);

  const src = hasSelectedClipping
    ? `${process.env.NEXT_PUBLIC_IMAGE_DOMAIN}${selectedClipping.url}`
    : `${mainImageObject?.domain ?? ""}${mainImageObject?.imgUrl ?? ""}`;

  const element = hasSelectedClipping
    ? paragraph
    : {
      images: [
        {
          clippings: value.clippings ?? [],
          title: value.title ?? "",
        },
      ],
    };

  const clipping = hasSelectedClipping
    ? selectedClipping._id
    : CROPS.desktop;

  const alt = value.title || epigraphe;
  return (
    <div className={styles["article-image-epi"]}>
      <Image
        element={element}
        src={src}
        alt={alt}
        clipping={clipping}
        width={dimensions?.width}
        height={dimensions?.height}
        className={styles["cover-image"]}
        {...(hasSelectedClipping
          ? { src }
          : { srcSet: CROPS })}
      // srcSet={CROPS}
      />

      <span className={styles.epigraphe}>{epigraphe}</span>

      <hr />

      <span className={styles["img-expand"]}>
        <button
          className={styles["open-img"]}
          aria-label="Open Image"
        >
          <ExpandImage />
        </button>
      </span>
    </div>
  );
};

export default Img;